import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClientProvider } from "@tanstack/react-query";
import { type FC, useState } from "react";
import { RouterProvider } from "react-router";

import { createQueryClient, createTrpcClient, TRPCProvider } from "src/api/trpc";
import { AuthProvider } from "src/auth/AuthProvider";
import { router } from "src/routes/router";
import { theme } from "src/theme/theme";
import "src/i18n";

export const App: FC = () => {
	const [queryClient] = useState(createQueryClient);
	const [trpcClient] = useState(createTrpcClient);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<QueryClientProvider client={queryClient}>
				<TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
					<AuthProvider>
						<RouterProvider router={router} />
					</AuthProvider>
				</TRPCProvider>
			</QueryClientProvider>
		</ThemeProvider>
	);
};
